import { Controller } from "stimulus";

// Inject styles for prior ratings indicators
const injectPriorRatingStyles = () => {
  if (document.getElementById('scenario-prior-rating-styles')) return;
  
  const style = document.createElement('style');
  style.id = 'scenario-prior-rating-styles';
  style.textContent = `
    .scenario-has-prior-rating {
      position: relative;
      background: linear-gradient(90deg, #fef3c7 0%, #ffffff 30%) !important;
      border-left: 3px solid #f59e0b !important;
    }
    .scenario-has-prior-rating .prior-rating-indicator {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin-left: 8px;
      padding: 2px 8px;
      background: #fbbf24;
      color: #78350f;
      border-radius: 10px;
      font-size: 10px;
      font-weight: 600;
      white-space: nowrap;
    }
    .scenario-has-prior-rating .prior-rating-indicator i {
      font-size: 9px;
    }
    .prior-rating-tooltip {
      position: absolute;
      right: 40px;
      top: 50%;
      transform: translateY(-50%);
      background: #1f2937;
      color: white;
      padding: 6px 10px;
      border-radius: 6px;
      font-size: 11px;
      white-space: nowrap;
      z-index: 1000;
      opacity: 0;
      pointer-events: none;
      transition: opacity 0.2s;
    }
    .scenario-has-prior-rating:hover .prior-rating-tooltip {
      opacity: 1;
    }
    .scenario-category-violation {
      background: linear-gradient(90deg, #fee2e2 0%, #ffffff 30%) !important;
      border-left: 3px solid #dc2626 !important;
    }
    .scenario-category-violation .category-violation-indicator {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      margin-left: 8px;
      padding: 2px 8px;
      background: #fca5a5;
      color: #7f1d1d;
      border-radius: 10px;
      font-size: 10px;
      font-weight: 600;
      white-space: nowrap;
    }
  `;
  document.head.appendChild(style);
};

const markSelectedScenarioViolations = (violatingScenarioIds = []) => {
  const ul = document.getElementById("evt-selected-list");
  if (!ul) return;

  const ids = violatingScenarioIds.map((id) => `${id}`);
  ul.querySelectorAll("li[data-id]").forEach((li) => {
    const isViolation = ids.includes(li.dataset.id);
    li.classList.toggle("scenario-category-violation", isViolation);

    let indicator = li.querySelector(".category-violation-indicator");
    if (isViolation && !indicator) {
      indicator = document.createElement("span");
      indicator.className = "category-violation-indicator";
      indicator.innerHTML = '<i class="fa fa-exclamation-triangle"></i> Not allowed';
      li.appendChild(indicator);
    } else if (!isViolation && indicator) {
      indicator.remove();
    }
  });
};

const getEventCategoryId = () => {
  const select = document.getElementById("event_event_category_id");
  return select?.value || "";
};

const updateScenarioCategoryNote = () => {
  const note = document.getElementById("evt-scenario-category-note");
  if (!note) return;

  const categorySelect = document.getElementById("scenario_category_select");
  const hasCategorySelected = categorySelect && categorySelect.value;
  const hasEventCategory = getEventCategoryId().length > 0;

  note.classList.toggle(
    "d-none",
    !hasCategorySelected || hasEventCategory
  );
};

const buildRatingToolsHtml = (tools, ratableType, ratableId) => {
  if (!tools || tools.length === 0) {
    return '<p class="text-muted small mb-0">No rating tools attached</p>';
  }

  const toolRows = tools
    .map((tool) => {
      const mandatoryChecked = tool.mandatory ? "checked" : "";
      const signatureChecked = tool.signature_required ? "checked" : "";
      const mandatoryId = `event_rt_mandatory_${ratableType}_${ratableId}_${tool.id}`;
      const signatureId = `event_rt_signature_${ratableType}_${ratableId}_${tool.id}`;

      return `
        <li class="event-ratable-rating-tool"
            data-rating-tool-id="${tool.id}"
            data-ratable-type="${ratableType}"
            data-ratable-id="${ratableId}">
          <span class="event-ratable-rating-tool__name">${tool.name}</span>
          <div class="event-ratable-rating-tool__flags">
            <label class="event-ratable-rating-tool__flag">
              <input type="checkbox"
                     id="${mandatoryId}"
                     data-flag="mandatory"
                     ${mandatoryChecked} />
              <span>Mandatory</span>
            </label>
            <label class="event-ratable-rating-tool__flag">
              <input type="checkbox"
                     id="${signatureId}"
                     data-flag="signature_required"
                     ${signatureChecked} />
              <span>Signature required</span>
            </label>
          </div>
        </li>`;
    })
    .join("");

  return `<ul class="list-unstyled mb-0">${toolRows}</ul>`;
};

const updateSelectedList = (json, type = "scenarios") => {
  let ul = null;
  let data_action = "";
  let list = [];
  let ratableType = "";
  if (type === "scenarios") {
    list = json.scenarios;
    ul = document.getElementById("evt-selected-list");
    data_action = "click->event-scenario-select#removeScenario";
    ratableType = "Scenario";
  } else if (type === "skills") {
    list = json.skills;
    ul = document.getElementById("evt-selected-skill-list");
    data_action = "click->event-scenario-select#removeSkill";
    ratableType = "Skill";
  } else if (type === "teaching_resources") {
    list = json.teaching_resources;
    ul = document.getElementById("evt-selected-teaching-resource-list");
    data_action = "click->event-scenario-select#removeTeachingResource";
  }
  ul.innerHTML = "";
  list.forEach((item) => {
    let li = document.createElement("li");
    li.className = "list-group-item evt-scenario-select";
    li.setAttribute("data-id", item.id);

    if (ratableType) {
      const row = document.createElement("div");
      row.className = "event-ratable-row";

      const title = document.createElement("span");
      title.className = "event-ratable-row__title";
      title.textContent = item.name;
      row.appendChild(title);

      let span = document.createElement("span");
      span.className = "pull-right";
      let icon = document.createElement("i");
      icon.setAttribute("data-action", data_action);
      span.appendChild(icon);
      icon.className = "fa fa-trash";
      row.appendChild(span);
      li.appendChild(row);

      const toolsWrapper = document.createElement("div");
      toolsWrapper.className = "event-ratable-rating-tools mt-2";
      toolsWrapper.innerHTML = buildRatingToolsHtml(
        item.rating_tools,
        ratableType,
        item.id
      );
      li.appendChild(toolsWrapper);
    } else {
      li.textContent = item.name;
      let span = document.createElement("span");
      span.className = "pull-right";
      let icon = document.createElement("i");
      icon.setAttribute("data-action", data_action);
      span.appendChild(icon);
      icon.className = "fa fa-trash";
      li.appendChild(span);
    }

    ul.appendChild(li);
  });
  updateDropdown(list, type);
};

const updateDropdown = (list, type = "scenarios") => {
  let ul = null;
  let data_action = "";
  if (type === "scenarios") {
    ul = document.getElementById("evt-scenario-list");
    data_action = "click->event-scenario-select#scenarioSelect";
  } else if (type === "skills") {
    ul = document.getElementById("evt-skill-list");
    data_action = "click->event-scenario-select#skillSelect";
  } else if (type == "teaching_resources") {
    ul = document.getElementById("evt-teaching-resource-list");
    data_action = "click->event-scenario-select#teachingResourceSelect";
  }

  let lis = ul.getElementsByTagName("li");
  for (var i = 0; i < lis.length; i++) {
    let item_id = lis[i].dataset.id;
    let found = list.find((s) => `${s.id}` === item_id);
    if (
      !found &&
      !lis[i].classList.contains("event-available-scenarios-header")
    ) {
      lis[i].className = "list-group-item";
      lis[i].setAttribute("data-action", data_action);
    } else if (!lis[i].classList.contains("event-available-scenarios-header")) {
      lis[i].className = "list-group-item list-group-item-success";
      lis[i].setAttribute("data-action", "");
    }
  }
};

const buildSelectorList = (json, selected_list, type = "scenarios", priorRatingsData = {}) => {
  let list = [];
  let ul = null;
  let data_action = "";
  if (type === "scenarios") {
    list = json.scenarios;
    ul = document.getElementById("evt-scenario-list");
    data_action = "click->event-scenario-select#scenarioSelect";
  } else if (type === "skills") {
    list = json.skills;
    ul = document.getElementById("evt-skill-list");
    data_action = "click->event-scenario-select#skillSelect";
  } else if (type === "teaching_resources") {
    list = json.teaching_resources;
    ul = document.getElementById("evt-teaching-resource-list");
    data_action = "click->event-scenario-select#teachingResourceSelect";
  }
  ul.innerHTML = "";
  let header = document.createElement("li");
  header.className = "event-available-scenarios-header list-group-item";
  let human_readable_type = type.replace(/_/g, " ");
  header.textContent =
    selected_list.length > 0
      ? `Available ${human_readable_type}, click to select`
      : `There are no ${human_readable_type} in the selected category.`;
  ul.appendChild(header);
  console.log("LIST", list);
  selected_list.forEach((scenario) => {
    let found = list.find((i) => i.id === scenario.id);
    console.log("FOUND", found);
    let li = document.createElement("li");
    
    // Check if this scenario has prior ratings
    const priorRating = priorRatingsData[scenario.id.toString()];
    const hasPriorRating = priorRating && priorRating.count > 0;
    
    let baseClass = found
      ? "list-group-item list-group-item-success"
      : "list-group-item evt-scenario-select";
    
    if (hasPriorRating) {
      baseClass += " scenario-has-prior-rating";
    }
    
    li.className = baseClass;
    
    // Create text content span
    let textSpan = document.createElement("span");
    textSpan.textContent = scenario.name;
    li.appendChild(textSpan);
    
    // Add prior rating indicator if applicable
    if (hasPriorRating) {
      let indicator = document.createElement("span");
      indicator.className = "prior-rating-indicator";
      indicator.innerHTML = `<i class="fa fa-exclamation-triangle"></i> ${priorRating.count} prior`;
      li.appendChild(indicator);
      
      // Add tooltip with learner names
      let tooltip = document.createElement("span");
      tooltip.className = "prior-rating-tooltip";
      tooltip.textContent = priorRating.learners.join(", ");
      li.appendChild(tooltip);
    }
    
    if (!found) {
      li.setAttribute("data-action", data_action);
    }
    li.setAttribute("data-id", scenario.id);
    ul.appendChild(li);
  });
};

const getList = (callback, selected_list = [], url, type, priorRatingsData = {}) => {
  fetch(url)
    .then((response) => response.json())
    .then((json) => {
      callback(json, selected_list, type, priorRatingsData);
    });
};

// Helper to get selected learner IDs
const getSelectedLearnerIds = () => {
  const learnersList = document.getElementById('evt-selected-learners-list');
  if (!learnersList) return [];
  return Array.from(learnersList.querySelectorAll('li[data-id]'))
    .map(li => li.dataset.id);
};

// Fetch prior ratings data for scenarios
const fetchPriorRatingsForScenarios = async (eventId, scenarioIds) => {
  const userIds = getSelectedLearnerIds();
  
  if (userIds.length === 0 || scenarioIds.length === 0) {
    return {};
  }
  
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  
  try {
    const response = await fetch(`/events/${eventId}/scenarios_with_prior_ratings`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({
        user_ids: userIds,
        scenario_ids: scenarioIds
      })
    });
    return await response.json();
  } catch (error) {
    console.error('Error fetching prior ratings:', error);
    return {};
  }
};

export default class extends Controller {
  connect() {
    console.log("CONNECTING TO EVENT SCENARIO SELECT");
    injectPriorRatingStyles();

    this.handleEventCategoryChange = this.handleEventCategoryChange.bind(this);
    this.eventCategorySelect = document.getElementById("event_event_category_id");
    if (this.eventCategorySelect) {
      this.eventCategorySelect.addEventListener("change", this.handleEventCategoryChange);
    }

    const violatingIds = (this.element.dataset.violatingScenarioIds || "")
      .split(",")
      .filter(Boolean);
    markSelectedScenarioViolations(violatingIds);
    updateScenarioCategoryNote();

    this.handleRatingToolToggle = this.handleRatingToolToggle.bind(this);
    this.element.addEventListener("change", this.handleRatingToolToggle);
  }

  disconnect() {
    if (this.eventCategorySelect) {
      this.eventCategorySelect.removeEventListener("change", this.handleEventCategoryChange);
    }
    this.element.removeEventListener("change", this.handleRatingToolToggle);
  }

  handleRatingToolToggle(event) {
    const target = event.target;
    if (!target.dataset.flag) return;

    const row = target.closest(".event-ratable-rating-tool");
    const eventId = parseInt(this.element.dataset.eventid, 10);
    if (!row || Number.isNaN(eventId)) return;

    const mandatory = row.querySelector('[data-flag="mandatory"]');
    const signatureRequired = row.querySelector('[data-flag="signature_required"]');

    const payload = {
      event_rating_tool_requirement: {
        event_id: eventId,
        ratable_type: row.dataset.ratableType,
        ratable_id: row.dataset.ratableId,
        rating_tool_id: row.dataset.ratingToolId,
        mandatory: mandatory?.checked || false,
        signature_required: signatureRequired?.checked || false,
      },
    };

    $.ajax({
      url: "/event_rating_tool_requirements",
      method: "POST",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify(payload),
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
        Accept: "application/json",
      },
      error: (response) => {
        target.checked = !target.checked;
        if (response.responseJSON && response.responseJSON.error) {
          alert(response.responseJSON.error);
        } else if (response.status === 404) {
          alert(
            "Could not save rating tool settings. The server may not have this feature deployed yet."
          );
        } else if (response.status === 403) {
          alert("You are not allowed to change rating tool settings for this event.");
        } else {
          alert("Could not save rating tool settings. Please try again.");
        }
      },
    });
  }

  handleEventCategoryChange = () => {
    updateScenarioCategoryNote();
    const categorySelect = document.getElementById("scenario_category_select");
    if (categorySelect && categorySelect.value) {
      this.categorySelect({ target: categorySelect });
    }
  };

  categorySelect = async (e) => {
    let event_id = this.element.dataset.eventid;
    const eventCategoryId = getEventCategoryId();
    updateScenarioCategoryNote();

    if (!eventCategoryId) {
      const ul = document.getElementById("evt-scenario-list");
      if (ul) {
        ul.innerHTML = "";
      }
      return;
    }

    try {
      const url = `/scenario_categories/${e.target.value}.json?event_category_id=${eventCategoryId}`;
      const response = await fetch(url);
      const json = await response.json();

      const scenarioIds = json.scenarios.map((s) => s.id);
      const priorRatingsData = await fetchPriorRatingsForScenarios(event_id, scenarioIds);

      const selectedResponse = await fetch(`/event_scenario_list/${event_id}.json`);
      const selectedJson = await selectedResponse.json();

      buildSelectorList(selectedJson, json.scenarios, "scenarios", priorRatingsData);
    } catch (error) {
      console.log("error", error);
    }
  };

  skillCategorySelect = (e) => {
    let event_id = this.element.dataset.eventid;
    fetch(`/skill_categories/${e.target.value}.json`)
      .then((response) => response.json())
      .then((json) => {
        getList(
          buildSelectorList,
          json.skills,
          `/event_skill_list/${event_id}.json`,
          "skills"
        );
      })
      .catch((error) => console.log("error", error));
  };

  teachingResourceCategorySelect = (e) => {
    let event_id = this.element.dataset.eventid;
    let url = encodeURI(
      `/teaching_resources_by_type/?format=json&type=${e.target.value}`
    );
    fetch(url)
      .then((response) => response.json())
      .then((json) => {
        console.log("JSON", json);
        getList(
          buildSelectorList,
          json,
          `/event_teaching_resource_list/${event_id}.json`,
          "teaching_resources"
        );
      })
      .catch((error) => console.log("error", error));
  };

  skillSelect = (e) => {
    const li = e.target.closest("li");
    if (!li) return;

    li.dataset.action = "";
    li.className = "list-group-item list-group-item-success";
    let data = {
      event: {
        skill_id: li.dataset.id,
        event_id: this.element.dataset.eventid,
        action: "add",
      },
    };
    this.databaseUpdate(data, "skills");
  };

  scenarioSelect = (e) => {
    // Get the li element (in case click was on a child element like span or indicator)
    const li = e.target.closest('li');
    if (!li) return;
    
    li.dataset.action = "";
    li.className = "list-group-item list-group-item-success";
    let data = {
      event: {
        scenario_id: li.dataset.id,
        event_id: this.element.dataset.eventid,
        action: "add",
      },
    };
    this.databaseUpdate(data, "scenarios");
  };

  teachingResourceSelect = (e) => {
    const li = e.target.closest("li");
    if (!li) return;

    li.dataset.action = "";
    li.className = "list-group-item list-group-item-success";
    let data = {
      event: {
        teaching_resource_id: li.dataset.id,
        event_id: this.element.dataset.eventid,
        action: "add",
      },
    };
    this.databaseUpdate(data, "teaching_resources");
    //e.target.value = "";
  };

  removeScenario = (e) => {
    let li = e.target.closest("li");
    let data = {
      event: {
        scenario_id: li.dataset.id,
        event_id: this.element.dataset.eventid,
        action: "remove",
      },
    };
    this.databaseUpdate(data, "scenarios");
  };

  removeSkill = (e) => {
    let li = e.target.closest("li");
    let data = {
      event: {
        skill_id: li.dataset.id,
        event_id: this.element.dataset.eventid,
        action: "remove",
      },
    };
    this.databaseUpdate(data, "skills");
  };

  removeTeachingResource = (e) => {
    let li = e.target.closest("li");
    let data = {
      event: {
        teaching_resource_id: li.dataset.id,
        event_id: this.element.dataset.eventid,
        action: "remove",
      },
    };
    this.databaseUpdate(data, "teaching_resources");
  };

  databaseUpdate = (data, type) => {
    let url = `/add_events_${type}/`;
    $.ajax({
      url: url,
      method: "POST",
      contentType: "application/json",
      dataType: "json",
      data: JSON.stringify(data),
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
        Accept: "application/json",
      },
      success: (response) => {
        updateSelectedList(response, type);
        if (type === "scenarios") {
          const violatingIds = (this.element.dataset.violatingScenarioIds || "")
            .split(",")
            .filter(Boolean);
          markSelectedScenarioViolations(violatingIds);
        }
      },
      error: (response) => {
        console.log("ERROR", response);
        if (response.status === 401) {
          alert(
            "You are not authorized to perform this action. Please check your permissions."
          );
        } else if (response.status === 403) {
          alert(
            "Access denied. You don't have permission to perform this action."
          );
        } else if (response.responseJSON && response.responseJSON.error) {
          alert(response.responseJSON.error);
        } else {
          alert("An error occurred. Please try again.");
        }
      },
    });
  };
}
